import React from "react";
//ui
import { Icon } from "antd";

const Marker = ({ text, type = "car", color = "#000000" }) => {
  return (
    <div style={{ display: "flex" }}>
      <Icon type={type} theme="twoTone" twoToneColor={color} />
      {text && (
        <span
          style={{
            fontSize: 15,
            fontWeight: "bold",
            borderRadius: 10,
            backgroundColor: "white",
            border: `${color} solid 1px`,
            padding: 5,
            color: color
          }}
        >
          {text}
        </span>
      )}
    </div>
  );
};

export default Marker;



// WEBPACK FOOTER //
// src/modules/presence/components/Marker.js